import { render, staticRenderFns } from "./AddPassengerToPassengerGroupDialog.vue?vue&type=template&id=56dcb8ac"
import script from "./AddPassengerToPassengerGroupDialog.vue?vue&type=script&lang=ts"
export * from "./AddPassengerToPassengerGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports